const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5.098 7.536C5.134 7.512 7.702 7.5 12.802 7.5H20.434L21.172 9.48C21.292 9.804 21.418 10.152 21.55 10.524C21.694 10.896 21.796 11.172 21.856 11.352C21.916 11.52 21.958 11.64 21.982 11.712H21.622L21.262 11.694C20.998 10.998 20.572 10.392 19.984 9.876C19.408 9.348 18.742 8.964 17.986 8.724C17.326 8.496 16.384 8.34 15.16 8.256C14.8 8.232 12.994 8.22 9.742 8.22C8.11 8.22 7.294 8.226 7.294 8.238C7.33 8.274 8.32 9.63 10.264 12.306C12.208 14.97 13.186 16.314 13.198 16.338C13.27 16.446 13.282 16.536 13.234 16.608L6.682 24.366C7.942 24.378 9.22 24.384 10.516 24.384C11.092 24.384 11.71 24.384 12.37 24.384C13.03 24.384 13.582 24.378 14.026 24.366C14.47 24.366 14.716 24.366 14.764 24.366C16.036 24.318 17.05 24.186 17.806 23.97C19.15 23.586 20.164 22.854 20.848 21.774C20.968 21.582 21.106 21.288 21.262 20.892H21.982C21.802 21.408 21.544 22.176 21.208 23.196C20.872 24.216 20.614 24.978 20.434 25.482L12.802 25.5C7.714 25.5 5.152 25.488 5.116 25.464C5.044 25.44 5.008 25.386 5.008 25.302C5.008 25.266 5.026 25.224 5.062 25.176C5.074 25.152 5.632 24.486 6.736 23.178C7.84 21.87 8.944 20.562 10.048 19.254L11.704 17.292C11.704 17.28 10.588 15.744 8.356 12.684L5.026 8.094L5.008 7.896C5.008 7.704 5.038 7.584 5.098 7.536Z",
  fill: "#1E3F6B"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 4,
  height: 6,
  transform: "matrix(1 0 0 -1 24 10)",
  stroke: "#0081CC"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 4,
  height: 6,
  transform: "matrix(1 0 0 -1 24 29)",
  stroke: "#0081CC"
});

const SvgEquationIntegrals3 = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEquationIntegrals3, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/equation-integrals-3.c284a0a9.svg";
export { ForwardRef as ReactComponent };